import { render, staticRenderFns } from "./BannerMODOOferta.vue?vue&type=template&id=34928e4e&scoped=true"
import script from "./BannerMODOOferta.vue?vue&type=script&lang=js"
export * from "./BannerMODOOferta.vue?vue&type=script&lang=js"
import style0 from "./BannerMODOOferta.vue?vue&type=style&index=0&id=34928e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34928e4e",
  null
  
)

export default component.exports